




















import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { BTableHelpers } from '@/mixins/bTable';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { DocumentWorkflowInformationTabModel } from '@/services/GeneratedApi';

export default Vue.extend({
  name: 'MStoreWorkflowInformationTab',
  mixins: [BTableHelpers],
  props: {
    documentId: {
      type: Number,
      required: true
    },
    cabinetId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      documentWorkflowInformationTab: {} as DocumentWorkflowInformationTabModel
    };
  },
  methods: {
    async getWorkflowInformationAsync(this: any, documentId: number, cabinetId: string) {
      try {
        this.documentWorkflowInformationTab = await ApiConfiguration.apiWithErrorPage().documentTabs.documentTabsWorkflowInformationTabDetail(documentId, cabinetId);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToWorkflowJob(this: any, item: any) {
      if (!item.queueId) {
        return;
      }
      this.$router.push({
        path: `/workflow/job/${item.queueId}/${item.workflowJobId}`
      });
    }
  },
  mounted() {
    this.getWorkflowInformationAsync(this.documentId, this.cabinetId);
  },
  components: {
    LoadingSpinner
  }
});
